import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

/**
 * Initialize and mount the React UI overlay
 * This will render on top of the Phaser game canvas
 */
export function initReactUI() {
  const rootElement = document.getElementById('react-root');
  
  if (!rootElement) {
    console.error('React root element not found');
    return;
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
